var map = {
	"./closeWindow.svg": "063e",
	"./example.svg": "1699",
	"./home.svg": "236d",
	"./noData.svg": "7c20",
	"./returnWindow.svg": "08d0",
	"./time.svg": "e053"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "16aa";